import styled, { css } from 'styled-components'

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
`

export const InnerContainer = styled.div`
    display: flex;
    justify-content: space-between;
`

export const Input = styled.input`
    display: none;
`
export const LabelHandle = styled.span(
    ({ theme }) => css`
        display: flex;
        justify-content: center;
        margin-left: 0.0625rem;
        align-items: center;
        width: 1.375rem;
        height: 1.375rem;
        background-color: ${theme.colors.white};
        border-radius: ${theme.typography.border.radius.xLarge};
        transition: background-color 0.5s ease;
        user-select: none;
    `,
)

export const Label = styled.label<{ $selected?: boolean }>(
    ({ theme, $selected }) => css`
        display: flex;
        align-items: center;
        width: 2.5rem;
        height: ${theme.layout.xSmall};
        background-color: #0000001f;
        border-radius: ${theme.typography.border.radius.xLarge};
        transition: background-color 0.5s ease;
        cursor: pointer;
        padding: 0;
        ${$selected &&
        css`
            background-color: ${theme.colors.tfwBlue12};
        `}
        & ${LabelHandle} {
            ${$selected &&
            css`
                transform: translateX(1rem);
                background-color: ${theme.colors.white};
            `}
        }
    `,
)

export const LabelIcon = styled.img`
    height: 0.375rem;
    width: 0.375rem;
`
export const OuterContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding-bottom: 1rem;
`
export const ReadMoreText = styled.span(
    ({ theme }) => css`
        text-decoration-line: underline;
        font-weight: ${theme.typography.font.lato.weight.bold};
        margin-left: ${theme.spacing.xxSmall};
        cursor: pointer;
    `,
)

export const Text = styled.span(
    ({ theme }) => css`
        margin-right: ${theme.spacing.small};
        font-size: 0.875rem;
        line-height: 1.375rem;
        color: #282828;
    `,
)

export const TextContainer = styled.span`
    display: flex;
    flex-direction: column;
`
